export default class DetailController {
    /* @ngInject */
    constructor($log, $location, $routeParams, $scope, $modal, $rootScope, ThingsService, MomentService) {
        this.$log = $log;
        this.$location = $location;
        this.$routeParams = $routeParams;
        this.$scope = $scope;
        this.$modal = $modal;
        this.$rootScope = $rootScope;
        this.ThingsService = ThingsService;
        this.MomentService = MomentService;

        this.thing = {};
        this.thingId = this.$routeParams.id;

        this.fromDate = this.MomentService.startOfWeek();
        this.toDate = this.MomentService.endOfDay();
        this.lastUpdated = null;
        this.settingsModal = undefined;
        this.domain = undefined;
        this.domainTrail = [];

        this.$rootScope.$on('cartSettingsUpdated', () => {
            this.getThing(this.thingId);
        });
    }

    $onInit() {
        this.getThing(this.thingId);
    }

    getThing(id) {
        this.ThingsService.getThing(id)
            .then((response) => {
                this.thing = response;
                this.timeSinceLastUpdate();
                return this.ThingsService.getDomains();
            })
            .then((rootDomain) => {
                this.domain = rootDomain;
                this.domainTrail = this.domain.trail(this.thing.domain.id);
            })
            .catch((error) => {
                this.$log.info(`Error getting things: ${error}`);
                this.$location.path('/login');
            });
    }

    timeSinceLastUpdate() {
        // unix-timestamp === timestamp * 1000
        const lastReported = this.MomentService.moment.unix(
            this.thing.shadow.metadata.reported.box_temperature.timestamp);
        this.lastUpdated = this.MomentService.moment(lastReported).fromNow();
    }

    showSettings(cartId) {
        if (this.settingsModal) {
            this.settingsModal.hide();
        }
        this.settingsModal = this.$modal({
            template: `<sb-cart-settings cart-id="'${cartId}'"></sb-cart-settings>`,
            placement: 'center',
            show: true,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/detail/detail-view/detail-view.controller.js